export default __webpack_public_path__ + "static/media/constellation_2.75ef8be4.png";